var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRenameGuestSolid = function SvgRenameGuestSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2.25c-1.259 0-2.32.846-2.647 2H5A2.75 2.75 0 0 0 2.25 7v12A2.75 2.75 0 0 0 5 21.75h8.174a1.994 1.994 0 0 1-.154-.77V18.86a2 2 0 0 1 .586-1.414l3.359-3.36c.233-.232.496-.43.78-.586v-.408A.76.76 0 0 0 17.75 13V7A2.75 2.75 0 0 0 15 4.25h-1.354a2.751 2.751 0 0 0-2.646-2H9ZM7.75 5c0-.69.56-1.25 1.25-1.25h2a1.25 1.25 0 0 1 0 2.5H9c-.69 0-1.25-.56-1.25-1.25Zm.75 9.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm-.5 1a3 3 0 0 0-3 3V20h7v-1.5a3 3 0 0 0-3-3H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.44 14.31a2.25 2.25 0 0 0-1.592.66l-3.358 3.358a.75.75 0 0 0-.22.53v2.122c0 .414.336.75.75.75h2.121a.75.75 0 0 0 .53-.22l3.36-3.358a2.25 2.25 0 0 0-1.592-3.841Zm-.531 1.72a.75.75 0 1 1 1.06 1.061l-3.138 3.14H15.77v-1.062l3.139-3.139Z",
    fill: "currentColor"
  })));
};
export default SvgRenameGuestSolid;